export { View as Badge } from './view'
